export const TV_SHOWS_LIST = [
  {
    title: "QUEENS",
    description:
      "Queens is an epic six-part natural history docuseries that follows six powerful sisterhoods in animal communities and sheds light on their unique feminine behaviours.",
    img: "https://img10.hotstar.com/image/upload/f_auto/sources/r1/cms/prod/9818/1708957999818-i",
    genres: ["Animals & Nature", "Documentary", "Adventure", "Informative"],
  },
  {
    title: "PHOTOGRAPHER",
    description:
      "Photographer takes viewers on a journey with the world’s most extraordinary visual storytellers as they shoot passion projects and recount their lives.",
    img: "https://img10.hotstar.com/image/upload/f_auto/sources/r1/cms/prod/8254/1711118358254-i",
    genres: [
      "Documentary",
      "People and Culture",
      "Informative",
      "Inspirational",
    ],
  },
  {
    title: "MEGAICONS",
    description:
      "Be a part of the journey into the life of iconic personalities through a scientific lens and conversations with friends and family.",
    img: "https://img10.hotstar.com/image/upload/f_auto/sources/r1/cms/prod/1406/801406-i",
    genres: ["Documentary", "Biographical", "Celebrities", "Inspirational"],
  },
  {
    title: "Faces of CLIMATE RESILENCE",
    description:
      "India’s local heroes take on the climate crisis by embracing nature-based solutions, traditional wisdom, and mobilising collective action to build resilience.",
    img: "https://img10.hotstar.com/image/upload/f_auto/sources/r1/cms/prod/5921/1719496325921-i",
    genres: ["Documentary", "Nature", "Community Centric", "Thought Provoking"],
  },
];
